// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"94":"d7ce87cb","605":"59767a3e","809":"62452d41","981":"ff97ed6c"}[chunkId] + ".chunk.js";
};